import { api } from "assets/scripts/utilities/api-clients";

import { omitKeys } from "src/assets/scripts/utilities/helpers";

const prepareEwayBill = (ewayBill) => {
  ewayBill = omitKeys(unref(ewayBill), ["invoice", "bill"]);

  return ewayBill;
};

export const autoGenerate = async (ewb) => {
  const response = await api.put("/account/ewaybills/auto-generate", ewb);

  return response;
};

export const cancel = async (params) => {
  const { eWayBill, removeFiles, path = "kam" } = params;

  const endpoints = {
    kam: {
      ewb: {
        cancel: "/kam/ewaybills/cancel",
      },
    },
    account: {
      ewb: {
        cancel: "/account/ewaybills/cancel",
      },
    },
  };

  const response = await api.put(endpoints[path].ewb.cancel, {
    _id: eWayBill._id,
    reason: eWayBill.reason,
    isFilesToBeRemoved: removeFiles,
  });

  return response;
};

export const complete = async (eWayBill) => {
  const response = await api.put(`/account/ewaybills/complete`, {
    _id: eWayBill._id,
  });

  return response;
};

export const index = async (options = {}) => {
  const { source = "kam", ...rest } = options;
  const url = {
    kam: "/kam/ewaybills",
    shipping: "/shipping/ewaybills",
  };
  const response = await api.get(url[source], rest);

  return response;
};

export const post = async (ewb) => {
  const response = await api.post("/kam/ewaybills", prepareEwayBill(ewb));

  return response;
};

export const put = async (
  ewb,
  { params: { showMessage = false, ...restParams } = {}, ...restOptions } = {},
) => {
  const response = await api.put("/account/ewaybills", ewb, {
    params: { showMessage, ...restParams },
    ...restOptions,
  });

  return response;
};

export const checkNumber = async (number) => {
  const response = await api.put("/account/ewaybills/number", number);

  return response;
};

export const get = async ({ id, source }) => {
  const url = {
    kam: `/kam/ewaybills/${id}`,
    shipping: `/shipping/ewaybill/${id}`,
  };
  const response = await api.get(url[source]);

  return response;
};
